import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import moment from 'moment';
import TrainIcon from '@material-ui/icons/Train';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Chip from '@material-ui/core/Chip';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const useStyles = makeStyles((theme) => ({
  avatarTren: {
    backgroundColor: '#01579b',
  },
  avatarColectivo: {
    backgroundColor: '#00b0ff',
  },
}));

export default ({ item, setServicioSeleccionado, servicioSeleccionado }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root} id=''>
      <CardHeader
        avatar={
          <Avatar
            aria-label='recipe'
            className={
              item.servicio.tipo.id === 1 ? classes.avatarTren : classes.avatarColectivo
            }
          >
            {item.servicio.tipo.id === 1 ? <TrainIcon /> : <AirportShuttleIcon />}
          </Avatar>
        }
        title={item.servicio.tipo.nombre.toUpperCase() + ' ' + item.servicio.numero}
        subheader={moment(item.servicio.desde.fecha).format('DD/MM/YYYY HH:mm')}
      />

      <CardContent>
        <List component='nav' aria-label='main mailbox folders'>
          <ListItem>
            <ListItemIcon>
              <ArrowForwardIosIcon />
            </ListItemIcon>
            <ListItemText primary={item.servicio.desde.nombre.toUpperCase()} />
            <ListItemSecondaryAction>
              <IconButton edge='end' aria-label='comments'>
                <Chip
                  size='small'
                  label={moment(item.servicio.desde.fecha).format('HH:mm')}
                ></Chip>
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <ArrowForwardIosIcon />
            </ListItemIcon>
            <ListItemText primary={item.servicio.hasta.nombre.toUpperCase()} />
            <ListItemSecondaryAction>
              <IconButton edge='end' aria-label='comments'>
                <Chip
                  size='small'
                  label={moment(item.servicio.hasta.fecha).format('HH:mm')}
                ></Chip>
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </CardContent>
      <CardActions disableSpacing>
        <FormControlLabel
          value={item.id}
          label='Seleccionar'
          checked={
            servicioSeleccionado
              ? servicioSeleccionado.servicio.id === item.servicio.id
              : false
          }
          control={<Radio />}
          onChange={() => setServicioSeleccionado(item)}
        />
      </CardActions>
    </Card>
  );
};
